import { Component, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { TitleCasePipe } from '@angular/common';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatTabNav, MatTabLink } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyCasePipeModule } from '~/core/helpers/currency-case-pipe/currency-case.module';

import { AuthenticationService } from '~/core/services/authentication.service';
import { NavigationService } from '~/core/services/navigation.service';

@Component({
  selector: 'app-menu-top-bar-basic-mobile-plus2',
  templateUrl: './menu-top-bar-basic-mobile-plus2.component.html',
  styleUrls: ['./menu-top-bar-basic-mobile-plus2.component.scss'],
  imports: [
    MatDrawer,
    FlexModule,
    MatIconModule,
    MatTabNav,
    MatTabLink,
    TranslateModule,
    TitleCasePipe,
    MatButtonModule,
    CurrencyCasePipeModule
  ]
})
export class MenuTopBarBasicMobilePlus2Component implements OnInit {
  @Input() title = '';
  @ViewChild('drawer', { static: true }) public drawerLogin: MatDrawer;
  @Output() back = new EventEmitter();
  @ViewChild('sidebarContainer', { read: ViewContainerRef }) sidebarContainer!: ViewContainerRef;
  private sidebarRef?: ComponentRef<any>;

  constructor(
    protected router: Router,
    protected authentication: AuthenticationService,
    protected navigation: NavigationService,
  ) { }

  ngOnInit(): void {
    this.drawerLogin.openedChange.subscribe((opened: boolean) => {
      if (opened && !this.sidebarRef) {
        import('../menu-login-sidebar-mobile-plus2/menu-login-sidebar-mobile-plus2.component').then(({ MenuLoginSidebarMobilePlus2Component }) => {
          this.sidebarRef = this.sidebarContainer.createComponent(MenuLoginSidebarMobilePlus2Component);
          this.sidebarRef.instance.openDeposit.subscribe(() => this.handleDeposit());
          this.sidebarRef.instance.toggleEvent.subscribe(() => this.drawerLogin.toggle());
        },
        );
      } else if (!opened && this.sidebarRef) {
        this.sidebarRef.destroy();
        this.sidebarRef = undefined;
      }
    });
  }

  finishComponent() {
    // TODO: navigate to company main start
    this.router.navigate(['']);
  }

  getUserBalance(): number {
    const user = this.authentication.getCurrentUser();
    return user && user.credits;
  }

  get isLoggedIn(): boolean {
    return this.authentication.isLoggedIn();
  }

  openMenuLogin() {
    const opened = !this.drawerLogin.opened;
    this.drawerLogin.toggle(opened);
  }

  handleDeposit() {
    this.navigation.openRequestDeposit();
  }
}
